import React, { useState } from 'react';
import { Modal, Button, message, Popconfirm } from 'antd';
import {
    subscripcionAgendaEstatusCode
  } from "../../../utils/enums/calendario";
import { actualizarEstatusSubscripcion } from '../../../services/subscripciones';

const SubscripcionesModal = ({ visible, subscripciones,  handleModalSubscripcionesCancel, actualizarInformacion }) => {


const handleCancelarSubscripcion = async (subscripcion) => {
    try {
        const dataToSend = {
            id: subscripcion.id,
            estatus: subscripcionAgendaEstatusCode.Suspendida.value,
        };
        var respuesta = await actualizarEstatusSubscripcion(dataToSend);
        if (respuesta.data === true)
        message.success("Subscripcion cancelada exitosamente.");
        actualizarInformacion();
    } catch (error) {
        console.error("Error cancelando subscripcion :", error);
        message.error(
        "Error cancelando subscripcion. Por favor, inténtelo de nuevo más tarde."
        );
    }
    }
  return (
    <Modal
      title="Subscripciones"
      visible={visible}
      onCancel={handleModalSubscripcionesCancel}
      footer={[
        <Button key="cancel" onClick={handleModalSubscripcionesCancel}>
          Cerrar
        </Button>
      ]}
      centered
    >
      <ul style={{ listStyle: 'none', padding: 0, maxHeight: '300px', overflow: 'auto' }}>
        {subscripciones && subscripciones.length > 0 ? (
            subscripciones.map((subscripcion, index) => (
            <li key={subscripcion.id} style={{ marginTop: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginRight: '10px', marginTop: '10px', fontSize: '14px' }}>{subscripcion.gestor}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h5 style={{ color: "var(--primary-color)", marginTop: '3px', marginLeft: '40px' }}>{subscripcion.fecha}</h5>
                    <Popconfirm
                    title="¿Está seguro de que desea cancelar la suscripción a este gestor?"
                    onConfirm={() => handleCancelarSubscripcion(subscripcion)}
                    okText="Sí"
                    cancelText="Cancelar"
                    >
                    <Button danger style={{ marginLeft: '150px' }} >Cancelar</Button>
                    </Popconfirm>
                </div>
                </div>
            </li>
            ))
        ) : (
            <p>Usted no presenta subscripciones a otro gestor.</p>
        )}
        </ul>

    </Modal>
  );
};

export default SubscripcionesModal;
